module.exports = __webpack_public_path__ + "static/img/champ-grand-open-banner-chatting.33b9bc9.jpg";